import React from 'react'
import { connect } from 'react-redux'
import { Outlet, Navigate } from 'react-router-dom'

/**
 * Checkout/ödeme sayfaları için guard: kullanıcı GİRİŞ YAPMIŞ **veya** bir SHARE
 * oturumu varsa (sessionStorage.tz_share_code) geçişe izin verir. Böylece dışarıdan
 * gelen guest, paylaşılan ürünü token olmadan satın alabilir; backend Authenticate
 * yine Share header'ı whitelist'li uçlarda doğrular (asıl güvenlik orada).
 */
function hasGuestSession() {
    try {
        return !!sessionStorage.getItem('tz_share_code')
            || !!sessionStorage.getItem('tz_widget_key')
            || !!sessionStorage.getItem('tz_storefront')
    } catch (e) { return false }
}

function ShareOrPrivate(props) {
    const authed = props.Login.auth && !props.Login.loading
    return (authed || hasGuestSession()) ? <Outlet /> : <Navigate to="/Login" />
}

const mapStateToProps = (state) => ({ Login: state.Login })

export default connect(mapStateToProps, {})(ShareOrPrivate)
